/* THX v8 — smart variants + Most popular tag + collection add-ons (extra % via ADDON5, only when ticked here) + sticky ATC + top sticky price. */
(function(){
  function notSticky(el){return !el.closest('sticky-add-to-cart')}
  function js(id){try{return JSON.parse(document.getElementById(id).textContent)}catch(e){return null}}
  function start(){
    var forms=[].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(notSticky);
    var form=null;for(var i=0;i<forms.length;i++){if(forms[i].closest('.productView')&&forms[i].querySelector('[type="submit"][name="add"]')){form=forms[i];break}}
    if(!form)for(var j=0;j<forms.length;j++){if(forms[j].querySelector('[type="submit"][name="add"]')){form=forms[j];break}}
    form=form||forms[0];if(!form)return;
    var mainBtn=form.querySelector('[type="submit"][name="add"]')||form.querySelector('[type="submit"]');
    var host=[].slice.call(document.querySelectorAll('variant-selects, variant-radios')).filter(notSticky)[0];
    if(!host)return;
    var variants=[];try{variants=JSON.parse(host.querySelector('script[type="application/json"]').textContent)}catch(e){}
    var mf=js('thx-sb-money')||'',VX=js('thx-vx')||{},CFG=js('thx-vx-cfg')||{auto:'king',tag:'Most popular',code:''};
    var hasMeta=Object.keys(VX).some(function(k){return VX[k]&&VX[k].b});
    function money(c){var n=c/100,a=n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g,','),b=n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
      if(!mf)return 'Rs. '+a;return mf.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){return k.indexOf('no_decimals')>-1?a:b}).replace(/<[^>]*>/g,'')}
    function clean(t){return (t||'').replace(':','').trim()}
    function esc(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML}

    var groups=[];
    host.querySelectorAll('.product-form__input--dropdown').forEach(function(box,idx){
      var sel=box.querySelector('select');if(!sel)return;
      var lab=box.querySelector('.form__label');
      groups.push({box:box,idx:idx,name:clean(lab&&lab.firstChild?lab.firstChild.textContent:sel.name),
        values:function(){return [].map.call(sel.options,function(o){return o.value})},
        cur:function(){return sel.value},
        pick:function(v){sel.value=v;sel.dispatchEvent(new Event('change',{bubbles:true}))},
        swatch:function(){return ''}});
    });
    host.querySelectorAll('fieldset.product-form__input').forEach(function(fs,idx){
      var lg=fs.querySelector('legend');
      groups.push({box:fs,idx:idx,name:clean(lg&&lg.firstChild?lg.firstChild.textContent:''),
        values:function(){return [].map.call(fs.querySelectorAll('.product-form__radio'),function(r){return r.value})},
        cur:function(){var c=fs.querySelector('.product-form__radio:checked');return c?c.value:''},
        pick:function(v){var r=[].filter.call(fs.querySelectorAll('.product-form__radio'),function(x){return x.value===v})[0];if(!r)return;var l=fs.querySelector('label[for="'+r.id+'"]');if(l)l.click();else r.click()},
        swatch:function(v){var r=[].filter.call(fs.querySelectorAll('.product-form__radio'),function(x){return x.value===v})[0];var p=r&&fs.querySelector('label[for="'+r.id+'"] .pattern');return p?p.getAttribute('style'):''}});
    });
    if(!groups.length)return;

    function ov(vt,k){return vt.options?vt.options[k]:vt['option'+(k+1)]}
    function selected(){return groups.map(function(g){return g.cur()})}
    function matchUpTo(vt,s,upto){for(var k=0;k<upto;k++){if(ov(vt,k)!==s[k])return false}return true}
    function exists(gi,v){var s=selected();return variants.some(function(vt){return ov(vt,gi)===v&&matchUpTo(vt,s,gi)})}
    function current(){var s=selected();return variants.filter(function(vt){return matchUpTo(vt,s,s.length)})[0]}
    var animFrom=-1;
    function choose(gi,v,after){
      var s=selected();s[gi]=v;
      for(var k=gi+1;k<groups.length;k++){
        var pool=variants.filter(function(vt){return matchUpTo(vt,s,k)});
        if(!pool.length)break;
        if(pool.some(function(vt){return ov(vt,k)===s[k]}))continue;
        var best=pool.filter(function(vt){return vt.available})[0]||pool[0];
        s[k]=ov(best,k);
      }
      var cur=selected();
      for(var m=groups.length-1;m>gi;m--){if(s[m]!==cur[m])groups[m].pick(s[m])}
      groups[gi].pick(v);
      animFrom=gi;
      setTimeout(function(){refresh();animFrom=-1;if(after)after()},120);
    }
    function tag(gi,v){
      if(hasMeta){
        if(gi!==groups.length-1)return '';
        var s=selected(),vt=variants.filter(function(x){return matchUpTo(x,s,gi)&&ov(x,gi)===v})[0];
        var x=vt&&VX[vt.id];return x&&x.b?'<span class="thx-seg__tag">'+esc(x.b)+'</span>':'';
      }
      if(CFG.auto&&String(v).toLowerCase().indexOf(CFG.auto)>-1)return '<span class="thx-seg__tag">'+esc(CFG.tag||'Most popular')+'</span>';
      return '';
    }
    function seg(g,gi,after){
      var wrap=document.createElement('div');wrap.className='thx-seg';
      var vals=g.values().filter(function(v){return !variants.length||exists(gi,v)});
      var anyTag=false;
      vals.forEach(function(v){
        var b=document.createElement('button');b.type='button';
        b.className='thx-seg__o'+(v===g.cur()?' on':'')+(animFrom>-1&&gi>animFrom?' thx-in':'');
        var sw=g.swatch(v),t=tag(gi,v);if(t)anyTag=true;
        b.innerHTML=(sw?'<i style="'+sw+'"></i>':'')+'<span></span>'+t;b.querySelector('span').textContent=v;
        b.onclick=function(){if(v===g.cur())return;choose(gi,v,after)};
        wrap.appendChild(b);
      });
      var mx=0,tot=0;vals.forEach(function(x){mx=Math.max(mx,x.length);tot+=x.length+3});
      if(vals.length>3||tot>34){wrap.classList.add('thx-seg--grid');wrap.style.setProperty('--thx-cols',vals.length<=3?(mx>20?Math.min(vals.length,2):vals.length):(mx<=9?3:(mx<=24?2:1)))}
      else if(anyTag){wrap.classList.add('thx-seg--grid');wrap.style.setProperty('--thx-cols',vals.length)}
      if(anyTag)wrap.classList.add('thx-seg--x');
      return wrap;
    }
    function inline(){
      groups.forEach(function(g,gi){
        if(!g.box.classList.contains('product-form__input--dropdown'))return;
        g.box.classList.add('thx-conv');
        var old=g.box.querySelector(':scope > .thx-seg');if(old)old.remove();
        g.box.appendChild(seg(g,gi));
        var h=g.box.querySelector('[data-header-option]');if(h)h.textContent=g.cur();
      });
    }

    var sb=document.getElementById('thx-sb');document.body.appendChild(sb);
    var tp=document.getElementById('thx-tp');document.body.appendChild(tp);
    var $=function(id){return document.getElementById(id)};
    var panel=$('thx-sb-panel'),sum=$('thx-sb-sum'),info=$('thx-sb-info'),selEl=$('thx-sb-sel'),priceEl=$('thx-sb-price'),atc=$('thx-sb-atc'),img=$('thx-sb-img'),
        tpSel=$('thx-tp-sel'),tpPrice=$('thx-tp-price'),tpCmp=$('thx-tp-cmp'),tpOff=$('thx-tp-off'),tpImg=$('thx-tp-img');
    var pv=form.closest('.productView')||document;
    var priceBox=pv.querySelector('.productView-price')||pv.querySelector('.price');
    function sized(src){if(!src)return '';if(src.indexOf('//')===0)src='https:'+src;return src+(src.indexOf('?')>-1?'&':'?')+'width=120'}

    /* ---- add-ons ---- */
    var ao=$('thx-ao-box'),disc=ao?(+ao.getAttribute('data-disc')||0):0;
    function aoNow(c){return disc>0?Math.round(c*(100-disc)/10000)*100:c}
    function aoPrice(r){var el=r.querySelector('.thx-ao__vid');if(el.tagName==='SELECT'){var o=el.options[el.selectedIndex];return o?+o.getAttribute('data-price'):0}return +el.getAttribute('data-price')||0}
    function aoTotal(){
      if(!ao)return;
      var v=current(),base=v?v.price:0,add=0,save=0,n=0;
      ao.querySelectorAll('.thx-ao').forEach(function(r){
        var p=aoPrice(r);r.querySelector('.thx-ao__now').textContent='+ '+money(aoNow(p));r.querySelector('.thx-ao__was').textContent=disc>0?money(p):'';
        if(r.querySelector('.thx-ao__cb').checked){n++;add+=aoNow(p);save+=p-aoNow(p)}
      });
      $('thx-ao-tot').classList.toggle('show',n>0);
      $('thx-ao-sum').textContent=money(base+add);
      $('thx-ao-sv').textContent=save>0?'You save '+money(save):'';
    }

    function sticky(){
      panel.innerHTML='';
      groups.forEach(function(g,gi){
        var box=document.createElement('div');box.className='thx-sb__grp';
        box.innerHTML='<p class="thx-sb__lbl"></p>';box.firstChild.innerHTML=g.name+': <b></b>';box.querySelector('b').textContent=g.cur();
        box.appendChild(seg(g,gi));panel.appendChild(box);
      });
      var lab=selected().filter(Boolean).join(' · ');
      selEl.textContent=lab;tpSel.textContent=lab;
      var v=current();
      if(v){
        priceEl.textContent=money(v.price);tpPrice.textContent=money(v.price);
        atc.disabled=!v.available;atc.textContent=v.available?'ADD TO CART':'SOLD OUT';
        var cmp=v.compare_at_price&&v.compare_at_price>v.price;
        tpCmp.textContent=cmp?money(v.compare_at_price):'';
        tpOff.textContent=cmp?Math.round((1-v.price/v.compare_at_price)*100)+'% OFF':'';
        var fi=v.featured_image&&(v.featured_image.src||v.featured_image);
        if(fi&&typeof fi==='string'){var s=sized(fi);if(img&&img.getAttribute('src')!==s)img.setAttribute('src',s);if(tpImg&&tpImg.getAttribute('src')!==s)tpImg.setAttribute('src',s)}
      }
      aoTotal();
    }
    function refresh(){inline();sticky()}
    function toggle(){var o=sb.classList.toggle('open');sum.setAttribute('aria-expanded',o);topBar()}
    sum.onclick=toggle;info.onclick=toggle;
    atc.onclick=function(){if(atc.disabled)return;sb.classList.remove('open');if(mainBtn)mainBtn.click();else if(form.requestSubmit)form.requestSubmit();else form.submit()};
    host.addEventListener('change',function(){setTimeout(refresh,80)});

    if(ao&&mainBtn){
      var anchor=host.closest('.productView-options')||host;
      anchor.parentNode.insertBefore(ao,anchor.nextSibling);ao.hidden=false;
      if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){ao.classList.add('in');io.disconnect()}},{threshold:.15});io.observe(ao)}else ao.classList.add('in');
      ao.querySelectorAll('.thx-ao').forEach(function(r){
        var cb=r.querySelector('.thx-ao__cb'),sel=r.querySelector('select.thx-ao__vid');
        cb.checked=false;
        cb.addEventListener('change',function(){r.classList.toggle('on',cb.checked);if(cb.checked){r.classList.add('pop');setTimeout(function(){r.classList.remove('pop')},200)}aoTotal()});
        if(sel)sel.addEventListener('change',aoTotal);
      });
      var passing=false;
      mainBtn.addEventListener('click',function(e){
        if(passing)return;
        var items=[].slice.call(ao.querySelectorAll('.thx-ao')).filter(function(r){return r.querySelector('.thx-ao__cb').checked}).map(function(r){return {id:+r.querySelector('.thx-ao__vid').value,quantity:1,properties:{'_thx_addon':'1'}}});
        if(!items.length)return;
        e.preventDefault();e.stopImmediatePropagation();
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){if(disc>0&&CFG.code)return fetch('/discount/'+encodeURIComponent(CFG.code),{credentials:'same-origin'})})
          .catch(function(){}).then(function(){
            ao.querySelectorAll('.thx-ao').forEach(function(r){r.querySelector('.thx-ao__cb').checked=false;r.classList.remove('on')});
            aoTotal();passing=true;mainBtn.click();passing=false;
          });
      },true);
    }
    refresh();

    function sg(){sb.classList.toggle('has-sg',!!$('thx-sg-ov'))}
    sg();setTimeout(sg,1500);
    var target=mainBtn||form,sbOn=false;
    function vis(show){sbOn=show;sg();sb.classList.toggle('show',show);sb.setAttribute('aria-hidden',!show);if(!show)sb.classList.remove('open');topBar()}
    sb.querySelector('.thx-sb__sg').addEventListener('click',function(){sb.classList.remove('open')});
    var hdr=document.querySelector('sticky-header')||document.querySelector('.section-header-mobile')||document.querySelector('.header-wrapper')||document.querySelector('header');
    function hb(){if(!hdr)return 0;var r=hdr.getBoundingClientRect();return (r.top<=1&&r.bottom>0)?Math.round(r.bottom):0}
    var tick=false;
    function topBar(){
      if(!priceBox||window.innerWidth>989){tp.classList.remove('show');return}
      var off=hb();tp.style.top=off+'px';
      var show=priceBox.getBoundingClientRect().bottom<off+4&&!sbOn&&!sb.classList.contains('open');
      tp.classList.toggle('show',show);tp.setAttribute('aria-hidden',!show);
    }
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){vis(!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(target)}
    else{window.addEventListener('scroll',function(){vis(target.getBoundingClientRect().bottom<0)},{passive:true})}
    window.addEventListener('scroll',function(){if(tick)return;tick=true;requestAnimationFrame(function(){tick=false;topBar()})},{passive:true});
    window.addEventListener('resize',topBar);
    tp.addEventListener('click',function(){var r=host.getBoundingClientRect();window.scrollTo({top:window.pageYOffset+r.top-hb()-70,behavior:'smooth'})});
    topBar();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();